import {
	CLEAR_OPERATION_MANAGEMENT_STATE,
	GET_ALL_OPERATIONS,
	GET_ALL_OPERATIONS_SUCCESS,
	GET_ALL_OPERATIONS_ERROR,
	GET_OPERATION_BY_ID,
	GET_OPERATION_BY_ID_SUCCESS,
	GET_OPERATION_BY_ID_ERROR,
	CREATE_OPERATION,
	CREATE_OPERATION_SUCCESS,
	CREATE_OPERATION_ERROR,
	UPDATE_OPERATION,
	UPDATE_OPERATION_SUCCESS,
	UPDATE_OPERATION_ERROR,
	DELETE_OPERATION,
	DELETE_OPERATION_SUCCESS,
	DELETE_OPERATION_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const OPERATION_URL = '/operationType';

const defaultState = () => ({
	operationsList: [],
	isLoadingOperations: '',
});

const state = defaultState();

const getters = {
	operationsList: (state) => state.operationsList,
	isLoadingOperations: (state) => state.isLoadingOperations === 'loading',
};

const mutations = {
	[CLEAR_OPERATION_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_OPERATIONS]: (state) => {
		state.isLoadingOperations = 'loading';
	},
	[GET_ALL_OPERATIONS_SUCCESS]: (state, data) => {
		state.operationsList = data;
		state.isLoadingOperations = 'success';
	},
	[GET_ALL_OPERATIONS_ERROR]: (state) => {
		state.isLoadingOperations = 'error';
	},
	[GET_OPERATION_BY_ID]: (state) => {
		state.isLoadingOperations = 'loading';
	},
	[GET_OPERATION_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingOperations = 'success';
	},
	[GET_OPERATION_BY_ID_ERROR]: (state) => {
		state.isLoadingOperations = 'error';
	},
	[CREATE_OPERATION]: (state) => {
		state.isLoadingOperations = 'loading';
	},
	[CREATE_OPERATION_SUCCESS]: (state) => {
		state.isLoadingOperations = 'success';
	},
	[CREATE_OPERATION_ERROR]: (state) => {
		state.isLoadingOperations = 'error';
	},
	[UPDATE_OPERATION]: (state) => {
		state.isLoadingOperations = 'loading';
	},
	[UPDATE_OPERATION_SUCCESS]: (state, data) => {
		state.isLoadingOperations = 'success';
	},
	[UPDATE_OPERATION_ERROR]: (state) => {
		state.isLoadingOperations = 'error';
	},
	[DELETE_OPERATION]: (state) => {
		state.isLoadingOperations = 'loading';
	},
	[DELETE_OPERATION_SUCCESS]: (state, data) => {
		state.isLoadingOperations = 'success';
	},
	[DELETE_OPERATION_ERROR]: (state) => {
		state.isLoadingOperations = 'error';
	},
};

const actions = {
	[GET_ALL_OPERATIONS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_OPERATIONS);
			localStorage.setItem(`lastReqAdm`, 'operationManagement/GET_ALL_OPERATIONS');

			http({
				method: 'GET',
				url: `${OPERATION_URL}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_OPERATIONS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_OPERATIONS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_OPERATION_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_OPERATION_BY_ID);

			http({
				method: 'GET',
				url: `${OPERATION_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_OPERATION_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_OPERATION_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_OPERATION]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_OPERATION);

			http({
				method: 'POST',
				url: `${OPERATION_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Tipo de Operação criado com sucesso.');
					commit(CREATE_OPERATION_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_OPERATION_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_OPERATION]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_OPERATION);

			http({
				method: 'PATCH',
				url: `${OPERATION_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Tipo de Operação editado com sucesso.');
					commit(UPDATE_OPERATION_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_OPERATION_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_OPERATION]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_OPERATION);

			http({
				method: 'DELETE',
				url: `${OPERATION_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Tipo de Operação excluído com sucesso.');
					commit(DELETE_OPERATION_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_OPERATION_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
